import { MedicalAppointment } from '../medical-appointment';
import { ValorizationEdit } from '../valorization-edit';
import { BillingMedicalOrder } from './billing-order-control';

export class BillingOrderControlEdit {
    public BillingMedicalOrder: BillingMedicalOrder;
    public MedicalAppointment: MedicalAppointment;
    public ValorizationEdit: ValorizationEdit;
    public PatientId: number;
    public BillingStateId?: number;
    public NoBillingReasonId?: number;
    public Observation: string;
}
